<template>
    <div class="other-investments">
        <div class="row">
            <div class="col">
                <other-investments-radio />
            </div>
        </div>

        <div class="row">
            <div class="col">
                <investment-region-radio />
            </div>
        </div>
    </div>
</template>

<script>
import OtherInvestmentsRadio from '@/modules/theme-details/OtherInvestmentsRadio';
import InvestmentRegionRadio from '@/modules/theme-details/InvestmentRegionRadio';

export default {
    name: 'OtherInvestments',
    components: {
        OtherInvestmentsRadio,
        InvestmentRegionRadio,
    },
};
</script>

<style scoped lang="scss">
  .other-investments {
    margin-top: 20px;
  }
</style>
